import {FC} from "react";
import {useTranslation} from "react-i18next";
import {TabRow} from "../../../tab-content";
import {OemTableBody} from "../../overview";
import {OemsProps} from "../../operational-hierarchy/overview-tab/OperationalOems";
import "./ClientOems.scss";

export const ClientOems: FC<OemsProps> = ({id, oems}) => {
  const {t} = useTranslation();
  return (
    <TabRow
      name={"client-oems"}
      header={<h4>{t("entity-detail.dealer.oems.details")}</h4>}>
      <OemTableBody id={id} oems={oems} />
    </TabRow>
  );
};
